import { Injectable } from '@angular/core';
import { Http, Response, Request, RequestOptionsArgs, RequestOptions, ConnectionBackend, Headers } from '@angular/http';
import { Observable, Subscription, Observer } from 'rxjs';

import { TokenService, EndpointsService, ClaimsService } from './services';
import { LogoutService } from './services/logout.service';

export class RequestQueueItem {
    constructor(public request: Request, public observer: Observer<any>) { }
}

@Injectable()
export class CustomHttp extends Http {
    private isRefreshingToken: boolean = false;
    private requestQueue: Array<RequestQueueItem> = [];
    private ignoreQueuingUrls: string[] = [];
    private noAuthorizationRequiredLinks: string[] = ['/token', '/forgotPassword','/resetPassword'];

    constructor(backend: ConnectionBackend, 
        defaultOptions: RequestOptions, 
        private tokenService: TokenService, 
        private endpointsService: EndpointsService,
        private logoutService : LogoutService) {
        super(backend, defaultOptions);
        this.ignoreQueuingUrls = [this.endpointsService.GET_CHART_DETAILS_BY_PROVIDERS_FOR_TODAY_URL, this.endpointsService.GET_CHART_DETAILS_FOR_TODAY_URL];
    }

    request(url: string | Request, options?: RequestOptionsArgs): Observable<Response> {
        let request = url as Request;

        if (!request)
            return super.request(url, options);

        if (request.url !== null && this.noAuthorizationRequired(request.url)) //if login let it pass
            return super.request(url, options);

        if (this.isRefreshingToken) {
            if (!this.ignoreQueuingUrl(request.url)) {
                let observable = Observable.create(obs => {
                    this.requestQueue.push(new RequestQueueItem(request, obs));
                });

                return observable;
            } else {
                return Observable.create(observer => {
                    setTimeout(function () {
                        observer.complete();
                    }, 100);
                });
            }
        }

        if (this.tokenService.isBearerTokenExpired()) {
            this.isRefreshingToken = true;
            return this.refresh(request).flatMap((response: Response) => {
                let token = response.json() && response.json().access_token;
                if (token) {
                    this.tokenService.setBearerToken(token)
                    this.tokenService.setRefreshToken(response.json().refresh_token);
                    this.tokenService.setBearerTokenExpiration(response.json()[".expires"]);
                    this.setHeaderRefreshToken(request);
                    this.isRefreshingToken = false;
                    this.executeRequestQueue();
                    return super.request(request, options);
                } else {
                    this.isRefreshingToken = false;
                    this.requestQueue.splice(0);
                    this.redirectToLoginIfNoRefreshTokenSet();
                }
            }).catch(error => {
                this.isRefreshingToken = false;
                this.requestQueue.splice(0);
                if (error && error.status === 400) {
                    setTimeout(() => {
                        if (this.tokenService.isBearerTokenExpired())
                            this.redirectToLoginIfNoRefreshTokenSet();
                        else
                            return super.request(request, options);
                    }, 100);
                }
                else
                    return Observable.throw(error);
            });
        }
        else {
            this.setHeaderRefreshToken(request);
            return super.request(url, options).catch(error => {
                if (error && (error.status === 401)) {
                    if (this.isRefreshingToken) {
                        if (!this.ignoreQueuingUrl(request.url)) {
                            let observable = Observable.create(obs => {
                                this.requestQueue.push(new RequestQueueItem(request, obs));
                            });

                            return <Observable<Response>> observable;
                        } else {
                            return <Observable<Response>> Observable.create(observer => {
                                setTimeout(function () {
                                    observer.complete();
                                }, 100);
                            });
                        }
                    }

                    this.isRefreshingToken = true;
                    return this.refresh(request).flatMap((response: Response) => {
                        let token = response.json() && response.json().access_token;
                        if (token) {
                            this.tokenService.setBearerToken(token)
                            this.tokenService.setRefreshToken(response.json().refresh_token);
                            this.tokenService.setBearerTokenExpiration(response.json()[".expires"]);
                            this.setHeaderRefreshToken(request);
                            this.isRefreshingToken = false;
                            this.executeRequestQueue();
                            return super.request(request, options);
                        } else {
                            this.isRefreshingToken = false;
                            this.requestQueue.splice(0);
                            this.redirectToLoginIfNoRefreshTokenSet();
                        }
                    }).catch(error => {
                        this.isRefreshingToken = false;
                        this.requestQueue.splice(0);
                        if (error && error.status === 400) {
                            setTimeout(() => {
                                if (this.tokenService.isBearerTokenExpired())
                                    this.redirectToLoginIfNoRefreshTokenSet();
                                else
                                    return super.request(request, options);
                            }, 100);
                        }
                        else
                            return Observable.throw(error);
                    });
                }
                else {
                    this.isRefreshingToken = false;
                    return Observable.throw(error);
                }
            });
        }
    }

    private executeRequestQueue() {
        let count = this.requestQueue.length;
        for (var i = 0; i < count; i++) {
            let requestItem = this.requestQueue[0];
            this.requestQueue.splice(0, 1);
            this.setHeaderRefreshToken(requestItem.request);
            super.request(requestItem.request).subscribe((response) => {
                requestItem.observer.next(response);
            });
        }
    }

    private redirectToLoginIfNoRefreshTokenSet() {
        this.logoutService.connectionTimeOut();
    }

    private setHeaderRefreshToken(request: Request) {
        if (!request.headers) {
            request.headers = new Headers();
        }

        request.headers.append('Authorization', 'Bearer ' + this.tokenService.getBearerToken());
    }

    private refresh(url: Request): Observable<Response> {
        let params: string = 'refresh_token=' + this.tokenService.getRefreshToken() + '&grant_type=refresh_token';
        let headers = new Headers();
        headers.append('Content-Type', 'application/x-www-form-urlencoded');
        return super.post(this.endpointsService.ACCOUNT_LOGIN, params, { headers: headers })
    }

    private ignoreQueuingUrl(url: string): boolean {
        for (var i = 0; i < this.ignoreQueuingUrls.length; i++)
            if (this.ignoreQueuingUrls[i].startsWith(url))
                return true;

        return false;
    }

     private noAuthorizationRequired(url: string): boolean {
        for (var i = 0; i < this.noAuthorizationRequiredLinks.length; i++)
            if (url.indexOf(this.noAuthorizationRequiredLinks[i]) >= 0)
                return true;
        return false;
    }

}


// WEBPACK FOOTER //
// ./src/app/core/custom-http.ts